import { nullable, optional } from '@abb-procure/api';
import { IdName } from '@abb-procure/data';
import * as t from 'io-ts';
import { AvailableFilterOptionDto } from './available-filter-option-dto.type';
import { AvailableSearchOptionDto } from './available-search-options-dto.type';

const SearchOptionsResponse = t.type(
  {
    tabs: nullable(optional(t.array(AvailableSearchOptionDto))),
    globalFilters: nullable(t.array(AvailableFilterOptionDto)),
    useFacets: nullable(t.boolean),
    useFuzzySearch: nullable(t.boolean),
    includeTotalCount: nullable(t.boolean),
    defaultFilterMode: IdName,
    defaultSearchMode: IdName,
    suggestionTimeoutMs: nullable(t.string),
    availableFilterModes: t.array(IdName),
    availableSearchModes: t.array(IdName),
  },
  'SearchOptionsResponse',
);

type SearchOptionsResponse = t.TypeOf<typeof SearchOptionsResponse>;
export { SearchOptionsResponse };
